import styled, { css } from 'styled-components';

import {
    Flex,
    Paragraph,
    spaceMixin,
    mediaMixin,
    token,
} from '@zillow/constellation';

const desktopTooltipBreakpoint = 'xxl';

export const StyledBodyContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0;
    ${mediaMixin('lg', css`
       padding: ${spaceMixin('md')};
    `)};
`;

export const StyledContentContainer = styled(Flex)`
    min-height: 550px;
    min-width: 0;
    padding: ${spaceMixin('md')} ${spaceMixin('sm')};
    background-color: ${token('colors.white')};
    flex: 1;

    .transition-wrapper {
        height: 100%;
    }

    @media only screen and (min-height: 900px) {
        min-height: 640px;
    }

    ${mediaMixin('xl', css`
        border-radius: 4px;
        padding: ${spaceMixin('lg')};
    `)};

    ${mediaMixin(desktopTooltipBreakpoint, css`
        max-width: 712px;
        min-height: 610px;
        border-radius: 4px;
        padding: ${spaceMixin('md')};
    `)};
`;

export const StyledSideContainer = styled.div`
    ${mediaMixin(desktopTooltipBreakpoint, css`
       width: 244px;
    `)};
`;

export const StyledCenterParagraph = styled(Paragraph)`
    text-align: center;
`;

export const StyledDesktopTitleParagraph = styled(Paragraph)`
    text-align: center;
    ${mediaMixin('sm_lte', css`
        display: none;
    `)};
`;

export const StyledMobileTitleParagraph = styled(Paragraph)`
    text-align: center;
    ${mediaMixin('md', css`
        display: none;
    `)};
`;

export const StyledDescriptionContainer = styled.div`
    padding-top: ${spaceMixin('md')};
    margin: auto;
    width: 100%;
    ${mediaMixin('md', css`
        max-width: 470px;
    `)};
`;

export const StyledTooltipIconWrapper = styled.div`
    padding-right: ${spaceMixin('xs')};
    ${mediaMixin(desktopTooltipBreakpoint, css`
        align-self: flex-start;
    `)};
    flex-shrink: 0;
`;

export const StyledMobileTooltip = styled.div`
    display: flex;
    align-items: center;
    padding: ${spaceMixin('sm')};
    background-color: ${token('colors.blue200')};
    border-top: 1px solid ${token('colors.gray300')};
    ${mediaMixin(desktopTooltipBreakpoint, css`
       display: none;
    `)};
`;

export const StyledDesktopTooltip = styled.div`
    display: none;
    ${mediaMixin(desktopTooltipBreakpoint, css`
        display: block;
        width: 220px;
        border-radius: 4px;
        border: 1px solid ${token('colors.blue300')};
        background-color: ${token('colors.blue200')};
        padding: ${spaceMixin('sm')};
        margin-left: ${spaceMixin('md')};
    `)};
`;

export const StyledIcon = styled.div`
    height: 120px;
    width: 120px;
`;
